var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "tr-nowrap"
    },
    [
      _c("th", { attrs: { scope: "row" } }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("input-field", {
              attrs: { placeholder: "Posición", id: "index" + _vm.index },
              model: {
                value: _vm.currentPosition,
                callback: function($$v) {
                  _vm.currentPosition = $$v
                },
                expression: "currentPosition"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success btn--text",
                attrs: { type: "button" },
                on: { click: _vm.cambiarIndice }
              },
              [_c("i", { staticClass: "fa fa-check" })]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("td", { on: { click: _vm.clickSelectNombre } }, [
        _vm.mostrarSelectNombre
          ? _c(
              "div",
              { staticClass: "multiselect-field" },
              [
                _c(
                  "multiselect",
                  {
                    attrs: {
                      tooltip: _vm.modelValue.selectedItem
                        ? _vm.modelValue.selectedItem.nombre
                        : undefined,
                      loading: _vm.isLoadingItem,
                      taggable: "",
                      label: "nombre",
                      options: _vm.listaProductos,
                      "preserve-search": true,
                      "track-by": "id",
                      placeholder: "Escriba y seleccione...",
                      selectedLabel: "Seleccionado",
                      selectLabel: "Presiona enter para seleccionar",
                      deselectLabel: "Presiona enter para eliminar"
                    },
                    on: {
                      input: _vm.inputItem,
                      "search-change": _vm.onSearchItem,
                      tag: _vm.addTagItem
                    },
                    model: {
                      value: _vm.modelValue.selectedItem,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "selectedItem", $$v)
                      },
                      expression: "modelValue.selectedItem"
                    }
                  },
                  [
                    _c("template", { slot: "noOptions" }, [
                      _c("span", [_vm._v("La lista esta vacía")])
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "noResult" }, [
                      _c("span", [
                        _vm._v(
                          "No se encontraron elementos. Considere cambiar la consulta de búsqueda."
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.errores.hasOwnProperty(
                  "detalles." + _vm.index + ".selectedItem.id"
                )
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.errores[
                                "detalles." + _vm.index + ".selectedItem.id"
                              ][0]
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          : _c("span", [
              _vm._v(
                _vm._s(
                  _vm.modelValue.selectedItem !== null
                    ? _vm.modelValue.selectedItem.nombre
                    : ""
                )
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _c(
            "textarea-field",
            {
              attrs: {
                maxlength: "65535",
                placeholder: "...",
                id: "descripcionItem" + _vm.index
              },
              model: {
                value: _vm.modelValue.descripcion,
                callback: function($$v) {
                  _vm.$set(_vm.modelValue, "descripcion", $$v)
                },
                expression: "modelValue.descripcion"
              }
            },
            [
              _vm.errores.hasOwnProperty(
                "detalles." + _vm.index + ".descripcion"
              )
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.errores[
                              "detalles." + _vm.index + ".descripcion"
                            ][0]
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("td", { on: { click: _vm.clickSelectNombre } }, [
        _vm.mostrarSelectNombre
          ? _c(
              "div",
              { staticClass: "multiselect-field" },
              [
                _c(
                  "multiselect",
                  {
                    attrs: {
                      tooltip: _vm.modelValue.selectedCategoria
                        ? _vm.modelValue.selectedCategoria.nombre
                        : undefined,
                      loading: _vm.isLoadingCategoria,
                      taggable: "",
                      label: "nombre",
                      options: _vm.listaCategorias,
                      "preserve-search": true,
                      "track-by": "id",
                      placeholder: "Escriba y seleccione...",
                      selectedLabel: "Seleccionado",
                      selectLabel: "Presiona enter para seleccionar",
                      deselectLabel: "Presiona enter para eliminar"
                    },
                    on: {
                      input: _vm.inputCategoria,
                      "search-change": _vm.onSearchCategoria,
                      tag: _vm.addTagCategoria
                    },
                    model: {
                      value: _vm.modelValue.selectedCategoria,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "selectedCategoria", $$v)
                      },
                      expression: "modelValue.selectedCategoria"
                    }
                  },
                  [
                    _c("template", { slot: "noOptions" }, [
                      _c("span", [_vm._v("La lista esta vacía")])
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "noResult" }, [
                      _c("span", [
                        _vm._v(
                          "No se encontraron elementos. Considere cambiar la consulta de búsqueda."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errores.hasOwnProperty(
                      "detalles." + _vm.index + ".selectedCategoria.id"
                    )
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.errores[
                                    "detalles." +
                                      _vm.index +
                                      ".selectedCategoria.id"
                                  ][0]
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          : _c("span", [
              _vm._v(
                _vm._s(
                  _vm.modelValue.selectedCategoria !== null
                    ? _vm.modelValue.selectedCategoria.nombre
                    : ""
                )
              )
            ])
      ]),
      _vm._v(" "),
      _c("td", { on: { click: _vm.clickSelectNombre } }, [
        _vm.mostrarSelectNombre
          ? _c("label", { attrs: { for: "esProducto" + _vm.index } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.modelValue.tipo_item,
                    expression: "modelValue.tipo_item",
                    modifiers: { lazy: true }
                  }
                ],
                attrs: {
                  value: "P",
                  type: "radio",
                  id: "esProducto" + _vm.index
                },
                domProps: { checked: _vm._q(_vm.modelValue.tipo_item, "P") },
                on: {
                  change: [
                    function($event) {
                      return _vm.$set(_vm.modelValue, "tipo_item", "P")
                    },
                    function($event) {
                      return _vm.$emit("updated")
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Producto")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mostrarSelectNombre
          ? _c("label", { attrs: { for: "esServicio" + _vm.index } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.modelValue.tipo_item,
                    expression: "modelValue.tipo_item",
                    modifiers: { lazy: true }
                  }
                ],
                attrs: {
                  value: "S",
                  type: "radio",
                  id: "esServicio" + _vm.index
                },
                domProps: { checked: _vm._q(_vm.modelValue.tipo_item, "S") },
                on: {
                  change: [
                    function($event) {
                      return _vm.$set(_vm.modelValue, "tipo_item", "S")
                    },
                    function($event) {
                      return _vm.$emit("updated")
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Servicio")])
            ])
          : _c("span", [
              _vm._v(
                _vm._s(
                  _vm.modelValue.tipo_item === "P" ? "Producto" : "Servicio"
                )
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.decimal,
                    id: "cantidad" + _vm.index
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit("updated")
                    }
                  },
                  nativeOn: {
                    keypress: function($event) {
                      return _vm.$emit("changed")
                    },
                    keyup: function($event) {
                      return _vm.calcularDescuentoTotal.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.modelValue.cantidad,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "cantidad", $$v)
                    },
                    expression: "modelValue.cantidad"
                  }
                },
                [
                  _vm.errores.hasOwnProperty(
                    "detalles." + _vm.index + ".cantidad"
                  )
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.errores[
                                  "detalles." + _vm.index + ".cantidad"
                                ][0]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _c("span", [
                _vm._v(_vm._s(_vm.decimalFormat(_vm.modelValue.cantidad)))
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money2,
                    id: "precio" + _vm.index
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit("updated")
                    }
                  },
                  nativeOn: {
                    keypress: function($event) {
                      return _vm.$emit("changed")
                    }
                  },
                  model: {
                    value: _vm.modelValue.precio,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "precio", $$v)
                    },
                    expression: "modelValue.precio"
                  }
                },
                [
                  _vm.errores.hasOwnProperty(
                    "detalles." + _vm.index + ".precio"
                  )
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.errores[
                                  "detalles." + _vm.index + ".precio"
                                ][0]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _c("span", [
                _vm._v(_vm._s(_vm.moneyFormat2(_vm.modelValue.precio)))
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money2,
                    id: "coste" + _vm.index
                  },
                  nativeOn: {
                    keypress: function($event) {
                      return _vm.$emit("changed")
                    }
                  },
                  model: {
                    value: _vm.modelValue.coste,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "coste", $$v)
                    },
                    expression: "modelValue.coste"
                  }
                },
                [
                  _vm.errores.hasOwnProperty("detalles." + _vm.index + ".coste")
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.errores[
                                  "detalles." + _vm.index + ".coste"
                                ][0]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _c("span", [
                _vm._v(_vm._s(_vm.moneyFormat(_vm.modelValue.coste)))
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.porcentaje,
                    id: "porcentajeDescuento" + _vm.index
                  },
                  nativeOn: {
                    keypress: function($event) {
                      return _vm.$emit("changed")
                    },
                    keyup: function($event) {
                      return _vm.calcularDescuentoTotal.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.modelValue.porcentaje_descuento,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "porcentaje_descuento", $$v)
                    },
                    expression: "modelValue.porcentaje_descuento"
                  }
                },
                [
                  _vm.errores.hasOwnProperty(
                    "detalles." + _vm.index + ".descuento_total"
                  )
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.errores[
                                  "detalles." + _vm.index + ".descuento_total"
                                ][0]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _c("span", [
                _vm._v(
                  _vm._s(_vm.decimalFormat(_vm.modelValue.porcentaje_descuento))
                )
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("td", { on: { click: _vm.clickSelectNombre } }, [
        _vm.mostrarSelectNombre
          ? _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    label: "nombre",
                    options: _vm.tarifas,
                    id: "iva" + _vm.index
                  },
                  on: { input: _vm.inputTarifa },
                  model: {
                    value: _vm.modelValue.selectedTarifa,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "selectedTarifa", $$v)
                    },
                    expression: "modelValue.selectedTarifa"
                  }
                }),
                _vm._v(" "),
                _vm.errores.hasOwnProperty("detalles." + _vm.index + ".id_iva")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.errores[
                                "detalles." + _vm.index + ".id_iva"
                              ][0]
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          : _c("span", [
              _vm._v(
                _vm._s(
                  _vm.modelValue.selectedTarifa !== null
                    ? _vm.modelValue.selectedTarifa.nombre
                    : ""
                )
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c("input-field", {
                attrs: {
                  readonly: "",
                  vMoney: "",
                  format: _vm.money,
                  id: "impuestos" + _vm.index
                },
                model: {
                  value: _vm.modelValue.total_impuestos,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "total_impuestos", $$v)
                  },
                  expression: "modelValue.total_impuestos"
                }
              })
            : _c("span", [
                _vm._v(_vm._s(_vm.moneyFormat(_vm.modelValue.total_impuestos)))
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c("input-field", {
                attrs: {
                  readonly: "",
                  vMoney: "",
                  format: _vm.money,
                  id: "impuestos" + _vm.index,
                  value: _vm.retencion
                }
              })
            : _c("span", [_vm._v(_vm._s(_vm.moneyFormat(_vm.retencion)))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c("input-field", {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "total" + _vm.index,
                  value: _vm.total,
                  readonly: ""
                }
              })
            : _c("span", [_vm._v(_vm._s(_vm.moneyFormat(_vm.total)))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c("input-field", {
                attrs: {
                  readonly: "",
                  vMoney: "",
                  format: _vm.porcentajeNegative,
                  id: "utilidad" + _vm.index,
                  value: _vm.porcentaje_utilidad
                }
              })
            : _c("span", [
                _vm._v(_vm._s(_vm.decimalFormat(_vm.porcentaje_utilidad)))
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("td", { on: { click: _vm.clickSelectNombre } }, [
        _c("label", { attrs: { id: "mostrarDetalle" + _vm.index } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.modelValue.mostrar_detalle,
                expression: "modelValue.mostrar_detalle",
                modifiers: { lazy: true }
              }
            ],
            attrs: { type: "checkbox", id: "mostrarDetalle" + _vm.index },
            domProps: {
              checked: Array.isArray(_vm.modelValue.mostrar_detalle)
                ? _vm._i(_vm.modelValue.mostrar_detalle, null) > -1
                : _vm.modelValue.mostrar_detalle
            },
            on: {
              change: function($event) {
                var $$a = _vm.modelValue.mostrar_detalle,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.modelValue,
                        "mostrar_detalle",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.modelValue,
                        "mostrar_detalle",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.modelValue, "mostrar_detalle", $$c)
                }
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(" ")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "td",
        { on: { click: _vm.clickSelectNombre } },
        [
          _vm.mostrarSelectNombre
            ? _c("input-field", {
                attrs: { id: "observacion" + _vm.index },
                model: {
                  value: _vm.modelValue.observacion,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "observacion", $$v)
                  },
                  expression: "modelValue.observacion"
                }
              })
            : _c("span", [_vm._v(_vm._s(_vm.modelValue.observacion))])
        ],
        1
      ),
      _vm._v(" "),
      _c("td", [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("eliminar", _vm.index)
              }
            }
          },
          [_c("i", { staticClass: "fa fa-trash-o" })]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37b42d8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b42d8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemProforma.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-37b42d8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemProforma.vue
// module chunks = 0